import { render, staticRenderFns } from "./RewardListMenu.vue?vue&type=template&id=65caccba&scoped=true"
import script from "./RewardListMenu.vue?vue&type=script&lang=js"
export * from "./RewardListMenu.vue?vue&type=script&lang=js"
import style0 from "./RewardListMenu.vue?vue&type=style&index=0&id=65caccba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65caccba",
  null
  
)

export default component.exports